export default "/images/disable-icon.png?e55e32ec2dfa9146a62b9d6b9134f137";